import styled from 'styled-components';

export const PartnerIcon = styled.img`
  display: block;
  object-fit: contain;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  max-width: none;
  border-radius: 12px;
`;
